


































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { PayoutRequest } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import FormatMoney from "@/components/FormatMoney";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import AddNewRequest from "./AddNewRequest.vue";
import RequestItem from "./RequestItem.vue";

export default defineComponent({
  name: "PayoutRequestsView",
  components: {
    RequestItem,
    FormatMoney,
    BasePage,
    BaseButton,
    BaseIcon,
    PageTitle,
    EmptyContent,
    InfiniteScroll,
    AddNewRequest,
  },
  props: {
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    primaryBalance: { type: Number, required: true },
    pendingBalance: { type: Number, required: true },
    requestsList: { type: Array as () => PayoutRequest[], required: true },
    hasActiveRequest: { type: Boolean, required: true },
  },
  setup(props) {
    const { authorities } = useAuthUser();
    const allowNewRequest = computed(() => checkAuthorities(authorities.value, ["createMyPayoutRequest"]));
    const emptyRequests = computed(() => !props.loading && props.requestsList.length === 0);
    const mainCurrency = computed(() => getMainCurrencyCode());
    const activeItem = ref("none");
    const isActiveItem = (item: PayoutRequest) => activeItem.value === item.id;
    const isPendingBalanceOpen = ref(false);

    const toggleActiveItem = (item: PayoutRequest) => {
      activeItem.value = item.id === activeItem.value ? "none" : item.id;
    };

    const togglePendingBalance = () => {
      isPendingBalanceOpen.value = !isPendingBalanceOpen.value;
    };

    return {
      allowNewRequest,
      emptyRequests,
      isActiveItem,
      toggleActiveItem,
      mainCurrency,
      isPendingBalanceOpen,
      togglePendingBalance,
    };
  },
});
